import { render, staticRenderFns } from "./wdocs.vue?vue&type=template&id=bf6cc350"
import script from "./wdocs.vue?vue&type=script&lang=js"
export * from "./wdocs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports